<template>
  <div class="box grow cursor-pointer" @click="gotoTrail()">
    <div class="box flex row">
      <span class="small-font" v-if="notificationDetails.eventAction === 'STATUS_CHANGE'"
        >[{{ trailLabel }}] The status has changed to {{ notificationDetails.eventCategory }}.</span
      >
      <span class="small-font" v-else-if="notificationDetails.eventAction === 'PROGRESSION'"
        >[{{ trailLabel }}] New threat progression has been detected.</span
      >
      <span class="small-font" v-else
        >[{{ trailLabel }}] The risk level has escalated to {{ notificationDetails.riskLevel }}.</span
      >
    </div>
    <div class="box flex grow" v-if="notificationDetails.eventAction === 'SEVERITY_CHANGE'">
      <risk-level-button
        v-if="notificationDetails.eventCategory === 'LOW_MED' || notificationDetails.eventCategory === 'LOW_HIGH'"
        :risk-level="'low'"
        class-list="box notification-action_before"
      />
      <risk-level-button v-else :risk-level="'medium'" class-list="box notification-action_before" />
      <div class="box">
        <i class="material-icons">arrow_forward</i>
      </div>
      <risk-level-button
        v-if="notificationDetails.eventCategory === 'LOW_HIGH' || notificationDetails.eventCategory === 'MED_HIGH'"
        :risk-level="'high'"
        class-list="box notification-action_after"
      />
      <risk-level-button v-else :risk-level="'medium'" class-list="box notification-action_after" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  TRAILSINFO_LIST_REQUEST,
  TRAILSINFO_LIST_SUCCESS,
  MITIGATED_TRAILS_REQUEST,
  MITIGATED_TRAILS_SUCCESS
} from '@/store/modules/trails/trailsinfo.type'
import RiskLevelButton from '@/components/button/RiskLevelButton.vue'
import { getUserFriendlyTrailLabel } from '@/utilities/trail.helper'

export default {
  name: 'NotificationTrailEvent',
  props: {
    notificationDetails: { type: Object }
  },
  data () {
    return {
      trailLabel: ''
    }
  },
  created () {
    if (this.trailsinfoReqStatus !== 'saved' || this.mitigatedTrailsReqStatus !== 'saved') {
      Promise.all([
        this.$store.dispatch(TRAILSINFO_LIST_REQUEST),
        this.$store.dispatch(MITIGATED_TRAILS_REQUEST)
      ]).then(
        trails => {
          this.$store.dispatch(TRAILSINFO_LIST_SUCCESS)
          this.$store.dispatch(MITIGATED_TRAILS_SUCCESS)
          this.trailLabel = this.getTrailLabel
        },
        errMsg => {
          console.log(errMsg)
        }
      )
    } else {
      this.trailLabel = this.getTrailLabel
    }
  },
  computed: {
    ...mapGetters([
      'trailsinfoReqStatus',
      'mitigatedTrailsReqStatus',
      'activeTrailsinfoRecords',
      'mitigatedTrailsRecords'
    ]),
    getAllTrails () {
      return this.activeTrailsinfoRecords.models
        .concat(this.mitigatedTrailsRecords.models)
    },
    getTrailLabel () {
      let trailLabel = _.find(this.getAllTrails, {
        trailIdHash: this.notificationDetails.eventResourceId
      })
      if (trailLabel) {
        return trailLabel.trailIdLabel
      }
      return getUserFriendlyTrailLabel(this.notificationDetails.eventResourceId)
    }
  },
  methods: {
    gotoTrail () {
      this.$emit('notification-toggle')
      this.$router.push({
        name: `attack-track-details`,
        params: { trailId: this.notificationDetails.eventResourceId }
      })
    }
  },
  components: {
    RiskLevelButton
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/riskscore_colors.css';

.notification-feed {
  background-color: var(--gray-50);
  margin: 10px 20px;
}

.card-content_icon {
  margin: auto 10px;

  > .box {
    line-height: 100px;
    vertical-align: middle;
  }

  .material-icons {
    border: 1px solid var(--main-gray);
    border-radius: 50%;
    color: white;
    background-color: var(--main-gray);
    padding: 2px;
  }
}

.card-content_details {
  margin: 10px 12px;

  > .box {
    margin: 10px 0px;
  }

  > .box:last-of-type {
    .box {
      margin-right: auto;
    }

    .notification-action_before,
    .notification-action_after {
      border: 1px solid var(--border-color);
      padding: 3px 10px;
      position: relative;
    }

    .notification-action_before::before {
      content: '';
      display: block;
      background-color: black;
      height: 1px;
      position: absolute;
      max-width: 105%;
      width: 105%;
      top: 50%;
      left: -2px;
    }
  }
}

.notification-action {
  .material-icons {
    font-size: 18px;
  }
}

.notification-action_mark_read {
  margin: 2px 0px;

  .circle {
    width: 14px;
    height: 14px;
    display: table-cell;
    border-radius: 50%;
    background: var(--primary-blue-400);
  }

  .read {
    background: var(--gray-200);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card/notification/NotificationTrailEvent.vue